export const IS_SIDEKICK_APP = process.env.REACT_APP_PROJECT_NAME === 'sidekick';

export const IS_VALIDATE_APP = process.env.REACT_APP_PROJECT_NAME === 'validate';
